import React, {useState} from 'react';
import {
    clearState,
    setApp,
    setCategory,
    setLoading,
    setUdn,
    setViewMode
} from "../../../redux/actions/generalActions/mainActions";
import {setForm} from "../../../redux/actions/generalActions/formActions";
import {connect} from "react-redux";
import {showLoader} from "../../../components/loader/loader";
import {Card, CardBody, CardTitle, Col, Row} from "reactstrap";
import {ButtonCollapseEye, GenericButton} from "../../../components/buttons/buttonsActions";
import Map3D from "../../../components/map3d/Map3D";

const TraceDetail = (props) => {

    const {udn, pointA, pointB, routAB, googleConfig} = props;

    // console.log(props);
    const notImplemented = () => {
        console.log("Not implemented yet")
    }

    return (
        <>
            <Map3D
                className="trace-map-container"
                routAB={routAB}
                pointA={pointA}
                pointB={pointB}
                googleConfig={googleConfig} // solo necesita googleConfig?.mapOptions.center;
                onMapClick={notImplemented}
                onRightClick={notImplemented}
                onMarkerClick={notImplemented}
                options={{showRouteMarkers: false, showRoutes: false, showEasyPath: true, showActivities: false, udn : udn, show3D : false }}
            />
        </>
    );
}

export default TraceDetail